import $ from "jquery";

let setAnalytics = null;

const init = () => {

  function loadScript() {
    _paq.push(['setConsentGiven']);
    (function() {
      var u="//analytics.kkt-marken.de/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', '12']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();

    localStorage.setItem('setAnalytics', '1');
    // console.log('Storage: ' + localStorage.getItem(setAnalytics));
  }

  // Wenn Statistik gesetzt, dann Checked und Script laden
  if (localStorage.getItem('setAnalytics') == '1') {
    // console.log('Checked: ' + localStorage.getItem(setAnalytics));
    $('#analyticsCheck').prop('checked', true);
    loadScript();
  }

  else {
    $('#analyticsCheck').prop('checked', false);
  }

  // Button Alle akzeptieren
  $('.cookiebar__button--all').click(function(event) {
    $('#analyticsCheck').prop('checked', true);
    loadScript();
  });

  // Detail bei Seitenaufruf verstecken und bei Klick anzeigen
  $('.cookiedetails').hide();

  $('.cookiebar__detail').click(function() {
    $('.cookiedetails').show();
  });

  // Cookiebar mit Klick auf Footer-Link einblenden und wieder schliessen
  $('.show-cookiebar').click(function() {
    if($('.cookiebar-hide').length > 0) {
      $('.cookiebar-hide').removeClass();
    }
    $('body').addClass('cookiebar--active');
    $('.cookiebar').addClass('cookiebar--active');
  });

  $('.cookiebar__button').click(function() {
    $('body').removeClass('cookiebar--active');
    $('.cookiebar').removeClass('cookiebar--active');
    $('.cookiedetails').hide();
  });

  $('#analyticsCheck').change(function() {
    if($('#analyticsCheck').is(':checked')) {
      loadScript();
    }
    else {
      localStorage.removeItem('setAnalytics');
      // console.log('Storage: ' + localStorage.getItem(setAnalytics));
      _paq.push(['forgetConsentGiven']);
      _paq.push(['optUserOut']);
      $('html').find('script[src="//analytics.kkt-marken.de/matomo.js"]').remove();
    }

  });
}
export default {init};
